import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8515c2a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "user-avatar__initials"
}
const _hoisted_3 = {
  key: 1,
  class: "user-avatar__placeholder"
}

import { computed } from 'vue';
import { UserI } from '@/types';
import { IonIcon } from '@ionic/vue';
import { personOutline } from 'ionicons/icons';
import { getFirebaseStorageResizedAvatar } from '@/services/methods';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: {
    user: {},
    clickable: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const userInitials = computed(() =>
  props.user?.alias ? props.user.alias[0] + props.user.alias[1] : ''
);

const imagePath = computed(() => {
  if (!props.user?.avatarUrl) {
    return '';
  }
  return getFirebaseStorageResizedAvatar(props.user.avatarUrl, 'icon');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "user-avatar",
    style: _normalizeStyle({ cursor: props.clickable ? 'pointer' : 'auto' }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', $event)))
  }, [
    (imagePath.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "user-avatar__img",
          src: imagePath.value,
          alt: ""
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (userInitials.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(userInitials.value), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(IonIcon), { icon: _unref(personOutline) }, null, 8, ["icon"])
              ]))
        ], 64))
  ], 4))
}
}

})